var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_1218)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.49996 1.63299C-0.386045 3.59199 -4.48823e-05 5.67299 -4.48823e-05 11.995C-4.48823e-05 17.245 -0.916045 22.508 3.87796 23.747C5.37496 24.132 18.639 24.132 20.134 23.745C22.13 23.23 23.754 21.611 23.976 18.788C24.007 18.394 24.007 5.60299 23.975 5.20099C23.739 2.19399 21.888 0.460985 19.449 0.109985C18.89 0.0289854 18.778 0.00498536 15.91 -1.46404e-05C5.73695 0.00498536 3.50696 -0.448015 1.49996 1.63299Z",
    fill: "url(#paint0_linear_2_1218)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9981 3.13898C8.36706 3.13898 4.91906 2.81598 3.60206 6.19598C3.05806 7.59198 3.13706 9.40499 3.13706 12.001C3.13706 14.279 3.06406 16.42 3.60206 17.805C4.91606 21.187 8.39206 20.863 11.9961 20.863C15.4731 20.863 19.0581 21.225 20.3911 17.805C20.9361 16.395 20.8561 14.609 20.8561 12.001C20.8561 8.53899 21.0471 6.30398 19.3681 4.62598C17.6681 2.92598 15.3691 3.13898 11.9941 3.13898H11.9981ZM11.2041 4.73598C18.7781 4.72398 19.7421 3.88199 19.2101 15.579C19.0211 19.716 15.8711 19.262 11.9991 19.262C4.93906 19.262 4.73606 19.06 4.73606 11.997C4.73606 4.85198 5.29606 4.73998 11.2041 4.73398V4.73598ZM16.7281 6.20698C16.1411 6.20698 15.6651 6.68298 15.6651 7.26998C15.6651 7.85698 16.1411 8.33298 16.7281 8.33298C17.3151 8.33298 17.7911 7.85698 17.7911 7.26998C17.7911 6.68298 17.3151 6.20698 16.7281 6.20698ZM11.9981 7.44998C9.48506 7.44998 7.44806 9.48799 7.44806 12.001C7.44806 14.514 9.48506 16.551 11.9981 16.551C14.5111 16.551 16.5471 14.514 16.5471 12.001C16.5471 9.48799 14.5111 7.44998 11.9981 7.44998ZM11.9981 9.04698C15.9031 9.04698 15.9081 14.955 11.9981 14.955C8.09406 14.955 8.08806 9.04698 11.9981 9.04698Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_1218",
    x1: 1.54598,
    y1: 22.4671,
    x2: 23.8514,
    y2: 3.16196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF543E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C837AB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_1218"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.6e95a2e06961e74752eb34247a067a32.svg";
export { ForwardRef as ReactComponent };